import * as Yup from 'yup';

export const customerDetailOverviewValidationSchema = Yup.object().shape({
    addresses: Yup.array()
        .of(
            Yup.object().shape({
                street: Yup.string().required('app.error.required'),
                zip: Yup.string().required('app.error.required'),
                city: Yup.string().required('app.error.required'),
                country: Yup.object().required('app.error.required'),
                isDefaultAddress: Yup.boolean().required('app.error.required'),
            })
        )
        .min(1, 'app.error.required'),
    mainEmail: Yup.string().email('app.error.email').required('app.error.required'),
    // The number documents print (GF 27.10.2026, #2326 R-245).
    mainPhone: Yup.string().required('app.error.required'),
    emails: Yup.array().of(
        Yup.object().shape({
            type: Yup.mixed().required(),
            email: Yup.string().email('app.error.email').required('app.error.required'),
        })
    ),
    phones: Yup.array().of(
        Yup.object().shape({
            type: Yup.mixed().required(),
            number: Yup.string().required('app.error.required'),
        })
    ),
    name: Yup.string().required('app.error.required'),
    // The GLN is optional, and a record without one reaches the form as an empty
    // string rather than as undefined — so both have to pass.
    glnNumber: Yup.string().test('glnNumber', 'app.error.glnLength', val => !val || val.length === 13),
});
